/** Tiny classnames utility — joins truthy strings with a space. */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}
